module.exports = __webpack_public_path__ + "static/media/img2.98e42fa1.jpg";